import { render } from "./KioskLayout.vue?vue&type=template&id=186ea572"
import script from "./KioskLayout.vue?vue&type=script&lang=js"
export * from "./KioskLayout.vue?vue&type=script&lang=js"

import "./KioskLayout.vue?vue&type=style&index=0&id=186ea572&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QInnerLoading,QDrawer,QHeader,QBtn,QToolbar,QIcon,QPageContainer,QScrollArea});
